import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { GetUsagesResponse, getOrderEsimUsage } from '@apis/order';

export const useOrderEsimUsage = (
  orderId: number,
  esimId: number,
  enabled: boolean
) => {
  const queryOptions: UseQueryOptions<
    PageResponse<GetUsagesResponse>,
    Error
  > = {
    queryKey: ['orderEsimUsage', orderId, esimId],
    queryFn: () => {
      return getOrderEsimUsage(orderId, esimId);
    },
    enabled: orderId > 0 && esimId > 0 && enabled,
  };
  return useQuery(queryOptions);
};
